import { FilterCriteriaEDT } from 'app/models/FilterCriteriaEDT';

export class FilterCriteriaListEdt {
    filters: FilterCriteriaEDT[];
}